<div class="plm-page">
  <header class="plm-header">
    <div>
      <h1>PLM operations</h1>
      <p>GPS ingest, geofences, SLA escalation, report release, backup jobs, and post-handover O&amp;M tickets.</p>
    </div>
  </header>

  <div class="plm-toolbar">
    <mat-form-field appearance="outline">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="projectId" (selectionChange)="reload()">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let p of projects" [value]="p.id">{{ p.project_name || p.project_identifier || p.id }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-tab-group>
    <mat-tab label="GPS / geofence">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="ingestGps()">
          <mat-form-field appearance="outline">
            <mat-label>Latitude</mat-label>
            <input matInput type="number" [(ngModel)]="gpsForm.latitude" name="glat" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Longitude</mat-label>
            <input matInput type="number" [(ngModel)]="gpsForm.longitude" name="glng" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Machine id</mat-label>
            <input matInput type="number" [(ngModel)]="gpsForm.machine_id" name="gmid" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Ingest fix</button>
        </form>
        <table mat-table [dataSource]="gps">
          <ng-container matColumnDef="t">
            <th mat-header-cell *matHeaderCellDef>Time</th>
            <td mat-cell *matCellDef="let row">{{ row.recorded_at | date:'short' }}</td>
          </ng-container>
          <ng-container matColumnDef="m">
            <th mat-header-cell *matHeaderCellDef>Machine</th>
            <td mat-cell *matCellDef="let row">{{ row.machine_id || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="g">
            <th mat-header-cell *matHeaderCellDef>Point</th>
            <td mat-cell *matCellDef="let row">{{ row.geometry?.coordinates?.join(', ') }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['t','m','g']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['t','m','g']"></tr>
        </table>
      </div>
      <div class="plm-card">
        <h3>Geofences</h3>
        <form class="plm-form" (ngSubmit)="addFence()">
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="fenceForm.name" name="fn" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Center lat</mat-label>
            <input matInput type="number" [(ngModel)]="fenceForm.latitude" name="flat" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Center lng</mat-label>
            <input matInput type="number" [(ngModel)]="fenceForm.longitude" name="flng" required />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Add box fence</button>
        </form>
        <table mat-table [dataSource]="fences">
          <ng-container matColumnDef="n">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let row">{{ row.name }}</td>
          </ng-container>
          <ng-container matColumnDef="a">
            <th mat-header-cell *matHeaderCellDef>Active</th>
            <td mat-cell *matCellDef="let row">{{ row.active ? 'Yes' : 'No' }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['n','a']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['n','a']"></tr>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="Escalation">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addPolicy()">
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="escForm.name" name="en" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Stage</mat-label>
            <input matInput [(ngModel)]="escForm.stage" name="es" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>SLA hours</mat-label>
            <input matInput type="number" [(ngModel)]="escForm.sla_hours" name="eh" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Add policy</button>
          <button mat-stroked-button type="button" (click)="evaluate()">Evaluate overdue</button>
        </form>
        <p *ngIf="overdue.length">Overdue: {{ overdue.length }} item(s)</p>
        <table mat-table [dataSource]="policies">
          <ng-container matColumnDef="n">
            <th mat-header-cell *matHeaderCellDef>Policy</th>
            <td mat-cell *matCellDef="let row">{{ row.name }} ({{ row.sla_hours }}h)</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['n']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['n']"></tr>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="Reports / backup">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addReport()">
          <mat-form-field appearance="outline">
            <mat-label>Report type</mat-label>
            <mat-select [(ngModel)]="reportForm.report_type" name="rt">
              <mat-option value="dpr">DPR</mat-option>
              <mat-option value="wcc">WCC pack</mat-option>
              <mat-option value="handover">Handover</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Draft</button>
        </form>
        <table mat-table [dataSource]="reports">
          <ng-container matColumnDef="t">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row">{{ row.report_type }}</td>
          </ng-container>
          <ng-container matColumnDef="s">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row"><span class="status-pill" [ngClass]="'status-' + row.status">{{ row.status }}</span></td>
          </ng-container>
          <ng-container matColumnDef="a">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-button color="primary" *ngIf="row.status !== 'released'" (click)="release(row)">Release</button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['t','s','a']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['t','s','a']"></tr>
        </table>
      </div>
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addBackup()">
          <mat-form-field appearance="outline">
            <mat-label>Label</mat-label>
            <input matInput [(ngModel)]="backupForm.label" name="bl" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Add job</button>
        </form>
        <table mat-table [dataSource]="backups">
          <ng-container matColumnDef="l">
            <th mat-header-cell *matHeaderCellDef>Job</th>
            <td mat-cell *matCellDef="let row">{{ row.label }} — {{ row.status }}</td>
          </ng-container>
          <ng-container matColumnDef="ok">
            <th mat-header-cell *matHeaderCellDef>Last OK</th>
            <td mat-cell *matCellDef="let row">{{ row.last_ok_at | date:'short' }}</td>
          </ng-container>
          <ng-container matColumnDef="a">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-button color="primary" (click)="runBackup(row)">Run</button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['l','ok','a']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['l','ok','a']"></tr>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="O&M tickets">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addOm()">
          <mat-form-field appearance="outline">
            <mat-label>Title</mat-label>
            <input matInput [(ngModel)]="omForm.title" name="ot" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <input matInput [(ngModel)]="omForm.description" name="od" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Priority</mat-label>
            <mat-select [(ngModel)]="omForm.priority" name="op">
              <mat-option value="low">Low</mat-option>
              <mat-option value="medium">Medium</mat-option>
              <mat-option value="high">High</mat-option>
              <mat-option value="critical">Critical</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Open ticket</button>
        </form>
        <table mat-table [dataSource]="tickets">
          <ng-container matColumnDef="t">
            <th mat-header-cell *matHeaderCellDef>Ticket</th>
            <td mat-cell *matCellDef="let row">{{ row.title }}</td>
          </ng-container>
          <ng-container matColumnDef="s">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row"><span class="status-pill" [ngClass]="'status-' + row.status">{{ row.status }} / {{ row.priority }}</span></td>
          </ng-container>
          <ng-container matColumnDef="a">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-button *ngIf="row.status !== 'closed'" (click)="closeOm(row)">Close</button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['t','s','a']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['t','s','a']"></tr>
        </table>
        <p *ngIf="!tickets.length" class="empty-msg">No O&amp;M tickets.</p>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
